module.exports = __webpack_public_path__ + "static/media/about-adc.dcc5f638.jpg";